// extracted by mini-css-extract-plugin
export default {"footer":"address-preferences_footer__Pt4hS"};